import React from 'react';

import Link from '../../../../library/link/link';
import Typography from '../../../../library/typography/typography';
import CirclesRating from '../../../../components/circles-rating/circles-rating';
import CarBumpRegularIcon from '../../../../shared/icons/car-bump-regular-icon';
import RoadRegularIcon from '../../../../shared/icons/road-regular-icon';
import SteeringWheelRegularIcon from '../../../../shared/icons/steering-wheel-regular-icon';
import TireLightIcon from '../../../../shared/icons/tire-light-icon';
import VolumeRegularIcon from '../../../../shared/icons/volume-regular-icon';

import { ProductData } from '../../../../shared/types/graphql-types';

import './product-list-review-details.scss';

interface ProductListReviewDetailsProps {
  numberOfReviews?: number;
  onClickReadReviewsFn?: () => void;
  product?: ProductData;
  productDetailUrl?: string;
}

function ProductListReviewDetails(props: ProductListReviewDetailsProps) {
  const {
    numberOfReviews = 0,
    onClickReadReviewsFn,
    product,
    productDetailUrl = ''
  } = props;

  const { corneringSteering, rideComfort, rideNoise, treadLife } =
    product || {};

  const shouldShowReviewDetails =
    Boolean(corneringSteering) ||
    Boolean(rideComfort) ||
    Boolean(rideNoise) ||
    (Boolean(treadLife) && numberOfReviews > 0);

  return (
    <div styleName={shouldShowReviewDetails ? 'alt' : 'container'}>
      {shouldShowReviewDetails && (
        <div styleName="header">
          <Typography styleName="title" tag="p">
            Customer Reviews
          </Typography>
        </div>
      )}

      {shouldShowReviewDetails ? (
        <>
          <div styleName="alt">
            <div styleName="header" />
            <div styleName="footer">
              {Boolean(rideComfort) && (
                <Typography styleName="sub-description" tag="div">
                  <div styleName="label-group">
                    <CarBumpRegularIcon styleName="icon" />
                    <span styleName="label">Ride Comfort</span>
                  </div>
                  <CirclesRating rating={rideComfort || 0} />
                </Typography>
              )}
              {Boolean(corneringSteering) && (
                <Typography styleName="sub-description" tag="div">
                  <div styleName="label-group">
                    <SteeringWheelRegularIcon styleName="icon" />
                    <span styleName="label">Cornering/Steering</span>
                  </div>
                  <CirclesRating rating={corneringSteering || 0} />
                </Typography>
              )}
              {Boolean(rideNoise) && (
                <Typography styleName="sub-description" tag="div">
                  <div styleName="label-group">
                    <VolumeRegularIcon styleName="icon" />
                    <span styleName="label">Ride Noise</span>
                  </div>
                  <CirclesRating rating={rideNoise || 0} />
                </Typography>
              )}
              {Boolean(treadLife) && (
                <Typography styleName="sub-description" tag="div">
                  <div styleName="label-group">
                    <RoadRegularIcon styleName="icon" />
                    <span styleName="label">Tread Life</span>
                  </div>
                  <CirclesRating rating={treadLife || 0} />
                </Typography>
              )}
            </div>
          </div>
          <Link
            onClick={onClickReadReviewsFn}
            size="small"
            styleName="read-reviews"
            to={`${productDetailUrl}#read-reviews`}
          >
            see all reviews
          </Link>
        </>
      ) : (
        <Typography size="extraSmall" styleName="no-reviews" tag="span">
          <TireLightIcon />
          There are currently no reviews for this product.
        </Typography>
      )}
    </div>
  );
}

export default ProductListReviewDetails;
